import { Component, EventEmitter, Injector, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { WorkFlowService } from 'src/app/components/workflow/workflow.service';
import { BaseComponent } from 'src/app/common/base/base.component';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { WFSectionConfig, WFStepConfig, WFTableConfig } from '../../workflow';
import { FormStatus } from 'src/app/services/forms/form-status';
import { Subscription } from 'rxjs';


@Component({
  selector: 'workflow-steps',
  templateUrl: './workflow-steps.component.html',
  styleUrls: ['./workflow-steps.component.scss']
})
export class WorkflowStepsComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {

  @Input() section?: WFSectionConfig;
  @Input() disabled?: boolean;
  @Input() wfSectionID!: number;
  @Input() sectionDropLists!: string[];
  @Input() stepDropLists!: string[];
  @Input() wfTableConfig?: WFTableConfig;


  @Output() refreshPreviousSection = new EventEmitter<number>();
  isDeletedSection?: boolean;
  steps?: WFStepConfig[];

  formStatuses?: FormStatus[];
  formStatusesSubs!: Subscription;

  constructor(
    protected override injector: Injector,
    public service: WorkFlowService
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadFormStatuses();

    this.steps = this.section?.wfStepConfigs.sort((a, b) => this.utils.sort(a.order, b.order));
    this.steps?.forEach(s => {
      if (s.wfStepStatusConfigs?.[0])
        s.wfStepStatusConfigs[0].formStatus = this.formStatuses?.find(f => f.id == s.wfStepStatusConfigs?.[0]?.status);
    });
  }

  override ngOnDestroy(): void {
    this.formStatusesSubs?.unsubscribe();
    super.ngOnDestroy();
  }

  loadFormStatuses() {
    this.formStatusesSubs = this.store.select(state => state.FormStatuses.data).subscribe(data => {
      if (data?.length) {
        this.formStatuses = data;
      }
    });
  }

  add() {
    if (!this.steps) this.steps = [];
    const maxNumber = !this.steps.length ? -1 : Math.max(...this.steps.map(s => s.order ?? 0));
    const step = { order: maxNumber + 1, name: 'New Step', wfSectionConfigID: this.section?.id } as WFStepConfig;
    this.steps.push(step);
    this.reorder();
  }

  delete(s: WFStepConfig) {
    const index = this.steps?.indexOf(s);
    if (index !== undefined && index > -1) {
      this.steps?.splice(index, 1);
    }
    this.reorder();
  }

  duplicate(s: WFStepConfig) {
    const step = this.utils.cloneDeep(s);
    step.id = 0;
    step.wfTaskConfigs?.forEach(task => {
      task.id = 0;
      task.wfActionConfigs?.forEach(a => a.id = 0);
      task.wfRoleConfigs?.forEach(r => r.id = 0);
    });
    step.wfStepStatusConfigs?.forEach(s => {
      s.id = 0;
    });
    this.steps?.push(step);
    this.reorder();
  }

  drop(event: CdkDragDrop<WFStepConfig[] | undefined>) {
    const previousList = event.previousContainer.data!;
    const currentList = event.container.data!;
    const draggedItem = previousList[event.previousIndex];

    if (event.previousContainer === event.container) {
      // calculate real index based on element positions
      const draggedElement = event.item.element.nativeElement;
      const siblings = Array.from(
        event.container.element.nativeElement.children
      ).filter(el => el !== draggedElement);

      const targetIndex = siblings.findIndex(
        (el: any) =>
          event.dropPoint?.y < el.getBoundingClientRect().top + el.offsetHeight / 2
      );

      const newIndex = targetIndex === -1 ? currentList.length - 1 : targetIndex;

      moveItemInArray(currentList, event.previousIndex, newIndex);
      this.reorder();
    } else {
      const sectionID = event.container?.data?.[0].wfSectionConfigID;
      const step = event.previousContainer?.data?.[event.previousIndex];
      const previosSectionID = step?.wfSectionConfigID;
      step!.wfSectionConfigID = sectionID;
      // handle cross-list drop
      transferArrayItem(
        previousList,
        currentList,
        event.previousIndex,
        event.currentIndex
      );
      draggedItem.wfSectionConfigID = currentList[0]?.wfSectionConfigID;
      this.reorder();
      this.refreshPreviousSection.emit(draggedItem.wfSectionConfigID);
    }
  }


  // drop(event: CdkDragDrop<WFStepConfig[] | undefined>) {
  //   if (event.previousContainer === event.container && this.steps) {
  //     moveItemInArray(this.steps, event.previousIndex, event.currentIndex);
  //     this.reorder();
  //   } else {
  //     const sectionID = event.container?.data?.[0].wfSectionConfigID;
  //     const step = event.previousContainer?.data?.[event.previousIndex];
  //     const previosSectionID = step?.wfSectionConfigID;
  //     step!.wfSectionConfigID = sectionID;
  //     transferArrayItem(
  //       event.previousContainer.data as WFTaskConfig[],
  //       event.container.data as WFTaskConfig[],
  //       event.previousIndex,
  //       event.currentIndex
  //     );
  //     this.reorder();
  //     this.refreshPreviousSection.emit(previosSectionID);
  //   }
  // }

  reorder() {
    let order = 0
    this.steps?.forEach(s => {
      s.order = order;
      order++;
    });
    this.section!.wfStepConfigs = this.steps ?? [];
  }

}
